import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgPe(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 9.868V13H5V5h3.077c.913 0 1.628.223 2.144.67.52.447.779 1.039.779 1.775 0 .777-.254 1.376-.762 1.797-.504.417-1.228.626-2.172.626H6.1zm0-.863h1.977c.589 0 1.04-.131 1.353-.395.313-.268.47-.652.47-1.154 0-.476-.157-.857-.47-1.143-.313-.286-.743-.434-1.29-.445H6.1v3.137zM18.449 17.302h-3.411v2.835H19V21h-5v-8h4.946v.868h-3.908v2.572h3.41v.862z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 1,
    height: 17,
    rx: 0.5,
    transform: "rotate(45 17 6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPe);

var PeOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { PeOutline as default };
